export default __webpack_public_path__ + "static/media/2015.51312bc8.png";